export const GET_ALL_CONTACT_QUERIES_REQUEST = "GET_ALL_CONTACT_QUERIES_REQUEST";
export const GET_ALL_CONTACT_QUERIES_SUCCESS = "GET_ALL_CONTACT_QUERIES_SUCCESS";
export const GET_ALL_CONTACT_QUERIES_FAIL = "GET_ALL_CONTACT_QUERIES_FAIL";
export const GET_ALL_CONTACT_QUERIES_RESET = "GET_ALL_CONTACT_QUERIES_RESET";

export const CHANGE_CONTACT_QUERY_STATUS_REQUEST = "CHANGE_CONTACT_QUERY_STATUS_REQUEST";
export const CHANGE_CONTACT_QUERY_STATUS_SUCCESS = "CHANGE_CONTACT_QUERY_STATUS_SUCCESS";
export const CHANGE_CONTACT_QUERY_STATUS_FAIL = "CHANGE_CONTACT_QUERY_STATUS_FAIL";
export const CHANGE_CONTACT_QUERY_STATUS_RESET = "CHANGE_CONTACT_QUERY_STATUS_RESET";

export const GET_ALL_DMP_CONTACT_QUERIES_REQUEST = "GET_ALL_DMP_CONTACT_QUERIES_REQUEST";
export const GET_ALL_DMP_CONTACT_QUERIES_SUCCESS = "GET_ALL_DMP_CONTACT_QUERIES_SUCCESS";
export const GET_ALL_DMP_CONTACT_QUERIES_FAIL = "GET_ALL_DMP_CONTACT_QUERIES_FAIL";
export const GET_ALL_DMP_CONTACT_QUERIES_RESET = "GET_ALL_DMP_CONTACT_QUERIES_RESET";

export const APPROVE_DATA_HERO_ACCOUNT_REQUEST = "APPROVE_DATA_HERO_ACCOUNT_REQUEST";
export const APPROVE_DATA_HERO_ACCOUNT_SUCCESS = "APPROVE_DATA_HERO_ACCOUNT_SUCCESS";
export const APPROVE_DATA_HERO_ACCOUNT_FAIL = "APPROVE_DATA_HERO_ACCOUNT_FAIL";
export const APPROVE_DATA_HERO_ACCOUNT_RESET = "APPROVE_DATA_HERO_ACCOUNT_RESET";